module.exports = __webpack_public_path__ + "img/pencil_icon.38450ab0.svg";